// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"Timeout_buttonWrapper__4POmg"};